import React from 'react';
import Dialog from 'material-ui/Dialog';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import { observe } from 'mobx';
import HttpClient from 'services/HttpClient';
import validate from 'validate.js';


import {
  CREATE_TUTORIAL_TYPE,
  EDIT_TUTORIAL_TYPE,
  TUTORIAL_CONSTRAINS,
  // QUESTION_CONSTRAINS,
  CPD_QUIZ_CONSTRAINS
} from 'constants/adminPupups';
import BaseInformation from 'modules/blocks/tutorial_popup/BaseInformation';
// import Preview from 'modules/blocks/tutorial_popup/Preview';
import CpdOptions from 'modules/blocks/tutorial_popup/CpdOptions';
import QuestionsQuiz from 'modules/blocks/tutorial_popup/QuestionsQuiz';
import { withRouter } from 'react-router-dom';



const TUTORIAL_REQUEST = '/api/v1/tutorials/';
const customContentStyle = {
  height: '100%',
  maxHeight: 'none'
};


@withRouter
@inject('editableCategoryStore')
@inject('categoryStore')
@inject('alertStore')
@inject('createTutorialStore')
@observer
export default class TutorialPopup extends React.Component {
  state = {
    open: false,
    tutorial_src: null
  };

  handleChange = (e) => {
    let newState = _.assign({}, this.state.formData, { [e.target.name]: e.target.value });
    this.setState({ formData: newState });
  };

  setStylesApp = () => {
    document.getElementById('app').style.position = 'fixed';
    document.getElementById('app').style.width = '100%';
  };

  componentWillMount() {
    this.listener = observe(this.props.editableCategoryStore, 'type', () => {
      if (this.props.editableCategoryStore.type.valueOf() === CREATE_TUTORIAL_TYPE ||
        this.props.editableCategoryStore.type.valueOf() === EDIT_TUTORIAL_TYPE
      ) {
        this.props.createTutorialStore.setError(null);
        if (this.props.editableCategoryStore.type.valueOf() === CREATE_TUTORIAL_TYPE) {
          this.props.createTutorialStore.initNewTutorial();
          this.setState({ open: true });
          document.body.classList.add('scrollable');
          this.setStylesApp();
        }
        if (this.props.editableCategoryStore.type.valueOf() === EDIT_TUTORIAL_TYPE) {
          this.loadTutorial();
          this.setState({ open: true });
          document.body.classList.add('scrollable');
          this.setStylesApp();
          this.setState({ open: true, tutorial_src: null })
        }
      }
    })
  }

  componentWillUnmount() {
    this.listener();
  }

  loadTutorial = () => {
    new HttpClient().get(TUTORIAL_REQUEST + this.props.editableCategoryStore.object_id).then(data => {
      this.props.createTutorialStore.setTutorial(data.body.data.tutorial)
    })
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    document.body.classList.remove('scrollable');
    document.getElementById('app').style = null;
  };

  addQuestion = () => {
    this.props.createTutorialStore.addQuestion();
  };

  handleSave = e => {
    e.preventDefault();
    let tutorial = _.assign({}, this.props.createTutorialStore.tutorial);
    let errors = this.validationProcess(tutorial);

    this.props.createTutorialStore.setError(errors);
    if (errors) {
      return;
    }
    let formData = new FormData();
    formData.append('category_id', this.props.editableCategoryStore.object_id);

    _.mapKeys(tutorial, (value, key) => {
      if (key === 'spd_quizzes') {
        value.forEach(el => {
          _.mapKeys(el, (valueQuestion, keyQuestion) => {
            formData.append('spd_quizzes_attributes[]' + keyQuestion, valueQuestion)
          })
        })
      }
      else if (key === 'questions') {
        value.forEach(el => {
          _.mapKeys(el, (valueQuestion, keyQuestion) => {
            formData.append('questions_attributes[]' + keyQuestion, valueQuestion)
          })
        })
      }
      else {
        formData.append(key, value);
      }
    });

    if (!tutorial.id)
      new HttpClient().multipart(TUTORIAL_REQUEST, formData, 'POST').then(data => {
        if (!this.props.location.search) {
          this.props.categoryStore.createTutorialOnList(this.props.editableCategoryStore.object_id, data.body.data.tutorial);
          this.setState({ open: false })
        }
        else {
          this.props.categoryStore.createTutorialOnShow(this.props.editableCategoryStore.object_id, data.body.data.tutorial);
          this.setState({ open: false });
          document.body.classList.remove('scrollable');
          document.getElementById('app').style = null;
        }
      }).catch((e) => {
        this.handleUnsuportableEntity(e)
      });
    else {
      new HttpClient().multipart(TUTORIAL_REQUEST + tutorial.id, formData, 'PUT').then(data => {
        if (!this.props.dontUpdate)
          this.props.categoryStore.updateTutorial(this.props.editableCategoryStore.object_id, data.body.data.tutorial);
        else
          this.props.initTutorial();
        this.setState({ open: false });
        document.body.classList.remove('scrollable');
        document.getElementById('app').style = null;
      }).catch((e) => {
        this.handleUnsuportableEntity(e)
      })
    }
  };

  handleValidationError = errors => {
    let newErrors = {};
    let maxEndTime;
    if (errors['questions.time']) {
      maxEndTime = errors['questions.time'][0];
    }
    if (errors.title) {
      newErrors = _.assign(newErrors, { title: 'Has already been taken' });
    }

    if (errors.friendly_id_url) {
      newErrors = _.assign(newErrors, { friendly_id_url: 'Has already been taken' });
    }
    if (errors.video_url) {
      newErrors = _.assign(newErrors, { video_url: 'Video not found' });
    }
    let questions = this.validateMaxEndTime(maxEndTime);
    if (!_.isEmpty(questions))
      newErrors = _.assign(newErrors, { questions: questions });
    this.props.createTutorialStore.setError(newErrors);
  };

  validateMaxEndTime = (time) => {
    let questions = [];
    let tutorial = _.assign({}, this.props.createTutorialStore.tutorial);
    tutorial.questions.forEach(el => {
      let endTime = parseInt(el.end_time);
      if (endTime > time)
        questions.push({ end_time: [`Maximum is ${this.getPrettyTime(time)}`], stubKey: el.stubKey })
    });
    return questions;
  };

  getPrettyTime = seconds => {
    let hours = parseInt(seconds / (60 * 60));
    let minutes = parseInt(((seconds - hours * 60 * 60) / 60));
    seconds = seconds - minutes * 60 - hours * 60 * 60;
    return `${hours} : ${minutes} : ${seconds}`
  };

  handleUnsuportableEntity = e => {
    if (e.status === 422)
      this.handleValidationError(e.body.data.errors);
    if (e.status === 400)
      this.props.createTutorialStore.setError({ video_url: 'Video url invalid' });
  };

  validationProcess = tutorial => {
    let errors = validate(tutorial, TUTORIAL_CONSTRAINS, { fullMessages: false });
    let spd_quizzes = [];
    // tutorial.questions.forEach(el => {
    //   let questionErrors = validate(el, QUESTION_CONSTRAINS, {fullMessages: false});
    //   _.assign(questionErrors, {stubKey: el.stubKey});
    //   if (questionErrors && !el['_destroy'])
    //     questions.push(questionErrors)
    // });
    tutorial.spd_quizzes.forEach((quiz, i) => {
      let quizErrors = validate(quiz, CPD_QUIZ_CONSTRAINS, {fullMessages: false});

      _.assign(quizErrors, {i});
      if (quizErrors && !quiz['_destroy'] && tutorial.cpd_status)
        spd_quizzes.push(quizErrors)
    });
    if(tutorial.spd_quizzes.length < 10 && tutorial.cpd_status)
      errors = _.assign({}, errors, { spd_quizzes: [{ title: 'Must be filled.' }] });

    if (!_.isEmpty(spd_quizzes))
      errors = _.assign({}, errors, { spd_quizzes: spd_quizzes });
    return errors

  };

  validateVideoTime = src => {
    this.setState({ tutorial_src: src });
  };

  render() {
    const { tutorial_src } = this.state;
    return (
      <div>
        <Dialog
          className="modal-wrapper category-handle"
          title="New Tutorial"
          modal={true}
          open={this.state.open}
          customContentStyle={customContentStyle}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <form className="create-category form-modal">
            <BaseInformation />
            {/* <div className="questions-wrapper">
              <h3>Questions</h3>
              <div className="questions-container">
                {this.props.createTutorialStore.tutorial.questions.map(el => <Preview key={el.stubKey}
                                                                                      stubKey={el.stubKey}/>)}
              </div>
              <div className="add-question-wrapper" onClick={this.addQuestion}>
                <span className="add-question">
                  <i className="ic ic-plus"/>
                </span>
                <span>Add question</span>
              </div>
            </div> */}

            <CpdOptions />

            <QuestionsQuiz
              getErrorToQuiz={this.props.createTutorialStore.getErrorToQuiz}
              error={this.props.createTutorialStore.errors}
            />

            <div className="button-set">
              <button className="btn gray small transparanted cancel-btn" type="reset"
                onClick={this.handleClose}>Cancel
              </button>
              <button className="btn gray small transparanted apply-btn" type="submit"
                onClick={this.handleSave}>Apply changes
              </button>
            </div>
          </form>
          <div style={{ display: 'none' }}>
            {tutorial_src &&
              <iframe src={tutorial_src}
                frameBorder="0"
                allowFullScreen
                onLoad={this.handleIframeLoad} />
            }
          </div>
        </Dialog>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./src/modules/categories/components/TutorialPopup.js